export const namespaced = true;

export const state = {
  loading: 0
};
export const mutations = {
  INCREMENT(state) {
    state.loading++;
    //console.log(state.loading, 'loading - INCREMENTed');
  },
  DECREMENT(state) {
    state.loading--;
    //console.log(state.loading, 'loading - DECREMENTed');
  }
};

export const actions = {
  newRequest({ commit }) {
    commit('INCREMENT');
  },
  finishedRequest({ commit }) {
    commit('DECREMENT');
  }
};

export const getters = {};
